export default "__VITE_ASSET__BujP5__y__"